export const API_URL = (process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:3002/' : '/');




// WEBPACK FOOTER //
// ./src/config.js